import React from 'react';
import GridTile from '~/src/root/components/ResultImageGrid/GridTile';
import { StyledGridItem } from '~/src/root/components/ResultImageGrid/VirtualResultsGrid/GridItem/GridItem.styled';

export const renderGridItem = (itemProps, index) => {
  const item = itemProps.items[index];
  const isLoading = !item && index < itemProps.total;

  const isItemSelected = item && itemProps.selected?.includes(item.id);

  return (
    (isLoading || item) && (
      <StyledGridItem>
        <GridTile
          info={item || {}}
          selectionAction={itemProps.selectionAction}
          isSelected={isItemSelected}
          allowSelect={itemProps.allowSelect}
          useImageClientSize={itemProps.useImageClientSize}
          isMultiple={itemProps.isMultiple}
          key={`${item?.url || item?.link || item?.id}`}
          tileNsSize={itemProps.tileNsSize}
          alwaysShowPreviewInfo={itemProps.alwaysShowPreviewInfo}
          customPreviewInfo={itemProps.customTilePreviewInfo}
          isLoading={isLoading}
        />
      </StyledGridItem>
    )
  );
};
